import { LayoutEditorShell } from '../../../lib/form-layout/LayoutEditorShell';
import {
  TRACT_FORM_FIELDS,
  TRACT_FORM_FIELD_NAMES,
  TRACT_DEFAULT_LAYOUT,
  type TractFormContext,
} from '../../../lib/form-layout/tract-fields';
import {
  useAdminActiveTractLayout,
  useUpdateTractFormLayout,
} from '../../../queries/tract-form-layout';
import type { TractInputSchema } from '../../../lib/schemas';

/**
 * Thin wrapper around LayoutEditorShell that wires the tract-form's
 * registry / queries / preview context.
 */
export function TractFormLayoutEditor() {
  const previewDefaults: TractInputSchema = {
    name: '',
    state: '',
    county: '',
    description: null,
    township: null,
    range: null,
    section: null,
    block: null,
    lot: null,
    abstract: null,
    survey: null,
    apn: null,
    gross_acres: null,
    notes: null,
  };

  const previewContext: TractFormContext = {};

  return (
    <LayoutEditorShell
      title="Tract form layout"
      breadcrumbLabel="Tract form layout"
      registry={TRACT_FORM_FIELDS}
      allNames={TRACT_FORM_FIELD_NAMES}
      defaultLayout={TRACT_DEFAULT_LAYOUT}
      useActive={useAdminActiveTractLayout}
      useUpdate={useUpdateTractFormLayout}
      previewDefaults={previewDefaults}
      previewContext={previewContext}
    />
  );
}
